export default "__VITE_ASSET__Bsy1pvdW__"